import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { FocusStyles } from '../../../styles/FocusStyles';
import { useIsMobileNavigation } from '../hooks/useIsMobileNavigation';
const StyledButton = styled.button `
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.375;
  padding: 0;

  ${props => props.isFullWidth &&
    css `
      display: block;
      width: 100%;
    `};

  color: ${props => props.hasPrimaryColor
    ? props.theme.colors.primary
    : props.theme.colors.darkergrey};

  &:hover {
    color: ${props => props.hasPrimaryColor
    ? props.theme.colors['primary-hover']
    : props.theme.colors.primary};
  }

  ${FocusStyles}
`;
function InnerButtonLink({ ariaControls = undefined, ariaExpanded = undefined, children, className, hasPrimaryColor = false, onClick, dataTestId = undefined, }, ref) {
    const isMobileNavigation = useIsMobileNavigation();
    return (React.createElement(StyledButton, { "aria-controls": ariaControls, "aria-expanded": ariaExpanded, className: className, hasPrimaryColor: hasPrimaryColor, isFullWidth: isMobileNavigation, onClick: onClick, ref: ref, "data-testid": dataTestId }, children));
}
export const ButtonLink = forwardRef(InnerButtonLink);
